import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IServiceQueue from "@/interfaces/service-queue.interface";
import serviceQueueService from "@/services/service-queue.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Props = RequestPagination;

type GetAllSwrParams = [string, number, number];

export type Return = RequestsBaseReturn<PaginatedResponse<IServiceQueue> | null>;

const useGetServiceQueues = ({ pageNumber, pageSize }: Props): Return => {
  const fetcher = useSWR<PaginatedResponse<IServiceQueue>, Error, GetAllSwrParams>(
    [SWR_KEYS.getServiceQueues, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      serviceQueueService.getAll({ pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false, shouldRetryOnError: false, errorRetryCount: 0 }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetServiceQueues;
